module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace6-21b216fe72e118eb6ce861d08b0ddc31.jpg";